var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMegaphone = function SvgIconMegaphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.011 2.376a1.75 1.75 0 0 1 1.86.242 17.1 17.1 0 0 0 6.473 3.403c.89.242 1.633.362 2.146.421a10 10 0 0 0 .758.058H18a4.75 4.75 0 0 1 .797 9.433l-1.1 4.396a1.74 1.74 0 0 1-2.482 1.142l-1.745-.868h-.002a1.74 1.74 0 0 1-.968-1.564v-2.828c-.346.066-.735.154-1.156.268a17.1 17.1 0 0 0-6.478 3.407A1.75 1.75 0 0 1 2 18.544V3.948a1.75 1.75 0 0 1 1.011-1.572M12.5 14.179c-.483.081-1.05.199-1.681.37A19 19 0 0 0 4 18.013V4.488a19 19 0 0 0 6.819 3.462c.63.172 1.198.29 1.681.37zm2-5.679V14H18a2.75 2.75 0 0 0 0-5.5zm0 7.5h2.219l-.888 3.544-1.331-.662z",
    clipRule: "evenodd"
  })));
};
export default SvgIconMegaphone;